import { render, staticRenderFns } from "./ConservancyFees.vue?vue&type=template&id=c82df274&scoped=true"
import script from "./ConservancyFees.vue?vue&type=script&lang=js"
export * from "./ConservancyFees.vue?vue&type=script&lang=js"
import style0 from "./ConservancyFees.vue?vue&type=style&index=0&id=c82df274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82df274",
  null
  
)

export default component.exports